import { html } from 'lit';
import { sectionHeading } from '../components/sectionHeading.js';
import type { LandingContent } from '../../shared/content/landingContent.js';
import { editorSemanticText } from '../editor/editorSemanticText.js';
import {
  editorNodeClass,
  editorNodeClick,
  editorNodePointerDown,
  editorNodeStyle,
  type LandingEditorRenderOptions,
} from '../editor/landingEditorRender.js';

export const requirementsSection = (content: LandingContent, editor?: LandingEditorRenderOptions) => html`
  <section
    class=${editorNodeClass(editor, 'section.requirements', 'vp-section vp-requirements-section')}
    style=${editorNodeStyle(editor, 'section.requirements')}
    @pointerdown=${(event: PointerEvent) => editorNodePointerDown(editor, 'section.requirements', event)}
    @click=${(event: MouseEvent) => editorNodeClick(editor, 'section.requirements', event)}
  >
    <div class="vp-shell">
      ${sectionHeading({
        eyebrow: content.requirements.eyebrow,
        title: content.requirements.title,
        highlight: content.requirements.titleHighlight,
        text: content.requirements.text,
        align: 'center',
        editor,
        elementPrefix: 'requirements',
      })}

      <div
        class=${editorNodeClass(editor, 'requirements.columns', 'vp-requirements-grid')}
        style=${editorNodeStyle(editor, 'requirements.columns')}
        @pointerdown=${(event: PointerEvent) => editorNodePointerDown(editor, 'requirements.columns', event)}
        @click=${(event: MouseEvent) => editorNodeClick(editor, 'requirements.columns', event)}
      >
        ${content.requirements.columns.map(
          (column, index) => html`
            <article
              class=${editorNodeClass(editor, `requirements.column.${index}`, 'vp-requirements-card reveal-card')}
              style=${editorNodeStyle(editor, `requirements.column.${index}`)}
              @pointerdown=${(event: PointerEvent) =>
                editorNodePointerDown(editor, `requirements.column.${index}`, event)}
              @click=${(event: MouseEvent) => editorNodeClick(editor, `requirements.column.${index}`, event)}
            >
              <span
                class=${editorNodeClass(
                  editor,
                  `requirements.column.${index}.icon`,
                  `${column.iconClass} vp-requirements-card-icon`,
                )}
                style=${editorNodeStyle(editor, `requirements.column.${index}.icon`)}
                @pointerdown=${(event: PointerEvent) =>
                  editorNodePointerDown(editor, `requirements.column.${index}.icon`, event)}
                @click=${(event: MouseEvent) => editorNodeClick(editor, `requirements.column.${index}.icon`, event)}
              ></span>
              ${editorSemanticText({
                editor,
                elementId: `requirements.column.${index}.title`,
                fallbackTag: 'h3',
                content: column.title,
              })}
              <ul class="vp-requirements-list">
                ${column.items.map(
                  (item, itemIndex) => html`
                    <li>
                      <span class="icon-[material-symbols--check-circle] vp-requirements-check"></span>
                      <span
                        class=${editorNodeClass(editor, `requirements.column.${index}.item.${itemIndex}`)}
                        style=${editorNodeStyle(editor, `requirements.column.${index}.item.${itemIndex}`)}
                        @pointerdown=${(event: PointerEvent) =>
                          editorNodePointerDown(editor, `requirements.column.${index}.item.${itemIndex}`, event)}
                        @click=${(event: MouseEvent) =>
                          editorNodeClick(editor, `requirements.column.${index}.item.${itemIndex}`, event)}
                      >
                        ${item}
                      </span>
                    </li>
                  `,
                )}
              </ul>
            </article>
          `,
        )}
      </div>
    </div>
  </section>
`;
